/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";

import { vikasLogo } from "../../../helper/imageConstant";
import { CiSearch } from "react-icons/ci";
import { Link, NavLink, useLocation } from "react-router-dom";
import routes from "../../../helper/routes";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa6";

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const handleOpen = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  // Apply the "no-scroll" class to the body when the menu is open
  if (mobileMenuOpen) {
    document.body.classList.add("no-scroll");
  } else {
    document.body.classList.remove("no-scroll");
  }
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  var handleChange = () => {
    if (
      document.getElementById("basic-navbar-nav")?.classList.contains("show")
    ) {
      document.getElementById("navi-btn").click();
    }
    scrollToTop();
  };
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <main className="w-full sticky top-0 z-50">
      <header className="bg-gradient shadow-lg">
        <nav
          className="basic-navbar-nav flex items-center justify-between p-4 lg:px-8"
          aria-label="Global"
        >
          {/* <button id="navi-btn" /> */}
          <div className="flex lg:flex-1">
            <a href="/" className="p-1.5 cursor-pointer">
              <img className="h-8 lg:h-12 w-full" src={vikasLogo} alt="logo" />
            </a>
          </div>
          <div className="flex lg:hidden">
            <button
              type="button"
              onClick={() => handleOpen()}
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5"
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                />
              </svg>
            </button>
          </div>
          <div className="hidden lg:flex lg:gap-x-12 menu_list">
            <NavLink
              to={"/"}
              onClick={handleChange}
              className={`${
                splitLocation[1] === ""
                  ? "text-[#A5302E] border-b-2 border-b-[#A5302E] pb-2"
                  : "text-[#222222]"
              } text-sm 2xl:text-lg  font-medium  transition-all ease-linear pb-2`}
            >
              {"Home"}
            </NavLink>
            <Link
              to={"/about-us"}
              onClick={handleChange}
              className={` ${
                splitLocation[1] === "about-us"
                  ? "text-[#A5302E] border-b-2 border-b-[#A5302E]"
                  : "text-[#222222]"
              } text-sm 2xl:text-lg font-medium transition-all ease-linear`}
            >
              {"About us"}
            </Link>
            <Link
              to={"/Careers"}
              onClick={handleChange}
              className={` ${
                splitLocation[1] === "Careers"
                  ? "text-[#A5302E] border-b-2 border-b-[#A5302E]"
                  : "text-[#222222]"
              } text-sm 2xl:text-lg font-medium transition-all ease-linear`}
            >
              {"Careers"}
            </Link>
            <Link
              to={"/contact-us"}
              onClick={handleChange}
              className={` ${
                splitLocation[1] === "contact-us"
                  ? "text-[#A5302E] border-b-2 border-b-[#A5302E]"
                  : "text-[#222222]"
              } text-sm 2xl:text-lg font-medium transition-all ease-linear`}
            >
              {"Contact us"}
            </Link>
          </div>
          <div className="hidden lg:flex lg:flex-1 lg:justify-end">
            <NavLink
              to={"/"}
              onClick={handleChange}
              className="text-sm font-bold"
            >
              <CiSearch className="text-xl" />
            </NavLink>
          </div>
        </nav>
        {mobileMenuOpen && (
          <div className="lg:hidden" role="dialog" aria-modal="true">
            <div
              className="bg-[url('../public/images/background_img/header_bg.png')] 
              bg-no-repeat bg-cover fixed inset-y-0 right-0 z-10 w-full overflow-y-hidden"
            >
              <div className="p-4 flex items-center justify-between">
                <NavLink
                  to={"/"}
                  onClick={handleChange}
                  className="-m-1.5 p-1.5"
                >
                  <img className="h-8 w-auto" src={vikasLogo} alt="" />
                </NavLink>
                <button
                  type="button"
                  onClick={() => handleOpen()}
                  className="-m-2.5 rounded-md p-2.5 text-[#fff]"
                >
                  <span className="sr-only">Close menu</span>
                  <svg
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <div className="h-screen overflow-y-hidden z-50">
                <div className="grid grid-cols-1 gap-20">
                  <div className="col-span-6 border-b border-b-[#ffff] pb-20">
                    <div className="my-16 divide-y divide-gray-500/10">
                      <div className="space-y-16 flex flex-col text-center">
                        {routes?.sidebarRoutes?.map(
                          ({ name, path, icon, items }, i) => (
                            <NavLink
                              key={i}
                              exact
                              to={path}
                              onClick={() => {
                                handleOpen();
                                handleChange();
                              }}
                              className="text-2xl font-normal leading-7 text-[#FFFFFF]"
                            >
                              {name}
                            </NavLink>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-span-6">
                    <div className="flex justify-center items-center gap-10">
                      <span className="bg-[#ffffff] text-[#A5302E] p-3">
                        <FaFacebookF />
                      </span>
                      <span className="bg-[#ffffff] text-[#A5302E] p-3">
                        <FaLinkedinIn />
                      </span>
                      <span className="bg-[#ffffff] text-[#A5302E] p-3">
                        <FaInstagram />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </header>
    </main>
  );
};

export default Navbar;
